module.exports = require('./dist/ReactCrop');


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.ecs-deploy.production/build/src/node_modules/react-image-crop/index.js
// module id = i+iS
// module chunks = 20